import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-walking': {
			// /walking?safe&mock-data&utm_source=FB&country=US&area=main-walking&exp=web_walking_gs_welcome_topic~1
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_walking_gs_welcome_topic'
					),
			},
		},
	},
]

export default config
